import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import StarsRating from 'Pods/Shared/StarsRating'

function UserSidebarRating({ rating = null }) {
  if (!rating) {
    return (<span>-</span>)
  }
  return (
    <div className="job-applicant__rating">
      {rating > 0 ? (
        <Fragment>
          <StarsRating rating={rating} readonly />
          <span className="rating"><span className="text-semibold">{rating}</span>/5</span>
        </Fragment>
      ) : (
        <Fragment>
          <StarsRating rating={rating} readonly />
          <span className="rating"><span className="text-semibold">N/A</span></span>
        </Fragment>
      )}
    </div>
  )
}

UserSidebarRating.propTypes = {
  rating: PropTypes.number,
}

export default UserSidebarRating
